import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { Attachment } from '@app/store/transport-layer/types/attachment';
import { WithId } from '@app/store/transport-layer/types/utility';

import { getDocumentsAttachment } from '..';

interface DocumentsAttachmentFileResponse {
  file: {
    extension: string;
    name: string;
    size: number;
    url: string;
  } | null;
}

const convertToDeprecatedAttachmentFileResponse = (
  attachment: WithId<Attachment['ToReceive']>
): DocumentsAttachmentFileResponse => {
  return {
    file:
      (attachment.input?.file && {
        extension: attachment.input.file.extension,
        name: attachment.input.file.name,
        size: attachment.input.file.size,
        url: attachment.input.file.url,
      }) ||
      null,
  };
};

/**
 * GET 첨부파일 파일 조회
 *
 * @deprecated This API is forwarded. Due to the path is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#37a98c3f8753458980df208999d7a55d
 */
export function getDocumentsAttachmentsFile(payload: {
  workspaceId: string;
  attachmentId: string;
  documentId: string;
}): Promise<DocumentsAttachmentFileResponse> {
  return getDocumentsAttachment(payload).then((response) =>
    convertToDeprecatedAttachmentFileResponse(response)
  );
}

export function deleteDocumentsAttachmentsFile({
  attachmentId,
  documentId,
  participantId,
  workspaceId,
}: {
  attachmentId: string;
  documentId: string;
  participantId: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/attachments/${attachmentId}/file`
    ),
    params: { participantId },
    method: 'DELETE',
    credentials: true,
  });
}

export function putDocumentsAttachmentsFile({
  workspaceId,
  attachmentId,
  documentId,
  fileId,
  fileName,
  participantId,
  token,
}: {
  workspaceId: string;
  attachmentId: string;
  documentId: string;
  fileId: string;
  fileName: string;
  participantId: string;
  token: string;
}) {
  return requestApi({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/attachments/${attachmentId}/file`
    ),
    method: 'PUT',
    data: {
      token,
      participantId,
      fileId,
      fileName,
    },
    credentials: true,
  });
}
